import { render, staticRenderFns } from "./villageList.vue?vue&type=template&id=d10fac88&scoped=true&"
import script from "./villageList.vue?vue&type=script&lang=js&"
export * from "./villageList.vue?vue&type=script&lang=js&"
import style0 from "./villageList.vue?vue&type=style&index=0&id=d10fac88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10fac88",
  null
  
)

export default component.exports